import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star } from 'lucide-react';
import { Section } from './Shared';
type PlanId = 'maestria' | 'base';
const plans: {
  id: PlanId;
  emoji: string;
  name: string;
  desc: string;
  ideal: string;
  oldPrice: string;
  price: string;
  href: string;
  recommended: boolean;
  includes: string[];
}[] = [{
  id: 'maestria',
  emoji: '🌟',
  name: 'MEGAPACK DIGITAL PARA TERAPEUTAS™',
  desc: 'El sistema completo para convertir tu conocimiento en una práctica visible, profesional y sostenible.',
  ideal: 'Ideal para terapeutas que quieren atraer más consultas, mejorar su comunicación y dejar de depender del boca a boca.',
  oldPrice: '$129.000',
  price: '$29.990 ARS',
  href: 'https://www.lumenakasha.com/cart/46955336335549:1',
  recommended: true,
  includes: ['📘 Identidad del Terapeuta Moderno™', '🎁 100 Ideas de Contenido para Terapeutas', '🎁 50 Reels que Generan Consultas', '🎁 Plantillas de WhatsApp', '➕ Consultorio Digital', '➕ El Sistema de Turnos', '➕ Instagram para Terapeutas', '➕ WhatsApp que Convierte', '➕ Calendario Anual de Contenidos']
}, {
  id: 'base',
  emoji: '📘',
  name: 'KIT DIGITAL PARA TERAPEUTAS™',
  desc: 'El sistema profesional para que más personas descubran tu trabajo.',
  ideal: 'Ideal para terapeutas que quieren empezar a construir una presencia profesional y conseguir más visibilidad.',
  oldPrice: '$89.000',
  price: '$19.990 ARS',
  href: 'https://www.lumenakasha.com/cart/46955331748029:1',
  recommended: false,
  includes: ['📘 Identidad del Terapeuta Moderno™', '🎁 100 Ideas de Contenido para Terapeutas', '🎁 50 Reels que Generan Consultas', '🎁 Plantillas de WhatsApp']
}];
export const Pricing = () => {
  const [selected, setSelected] = useState<PlanId>('maestria');
  const selectedPlan = plans.find(p => p.id === selected)!;
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-aqua/20" data-id="element-377">
      <div className="text-center mb-10" data-id="element-378">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-darkGreen" data-id="element-379">
          ELEGÍ TU <span className="green-gradient-text" data-id="element-380">KIT</span>
        </h2>
        <p className="text-brand-text/70 mt-3 text-sm md:text-base" data-id="element-381">
          ⏰ El precio de lanzamiento finaliza pronto. Después aumenta y no
          vuelve.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-382">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} whileTap={{
          scale: 0.99
        }} aria-pressed={isSelected} className={`w-full text-left rounded-2xl md:rounded-3xl p-4 md:p-6 border-2 transition-all duration-300 ${isSelected ? 'border-brand-aqua bg-white shadow-[0_0_24px_rgba(13,148,136,0.2)]' : 'border-brand-aqua/20 bg-white/70 hover:border-brand-aqua/50'}`} data-id="element-383">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-384">
                <div className="shrink-0 mt-1" data-id="element-385">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-aqua' : 'border-brand-aqua/40'}`} data-id="element-386">
                    {isSelected && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-aqua" data-id="element-387" />}
                  </div>
                </div>

                <div className="flex-1 min-w-0" data-id="element-388">
                  {plan.recommended && <div className="flex items-center gap-1.5 mb-1.5 text-brand-aqua" data-id="element-389">
                      <Trophy className="w-4 h-4 fill-brand-aqua" data-id="element-390" />
                      <Star className="w-3.5 h-3.5 fill-brand-aqua" data-id="element-391" />
                      <span className="text-[10px] md:text-sm font-bold tracking-wider uppercase" data-id="element-392">
                        Más elegido
                      </span>
                    </div>}

                  <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-393">
                    <div className="min-w-0" data-id="element-394">
                      <h3 className="font-serif font-bold text-sm md:text-lg text-brand-darkGreen leading-tight" data-id="element-395">
                        <span className="mr-1.5" data-id="element-396">{plan.emoji}</span>
                        {plan.name}
                      </h3>
                      <p className="text-xs md:text-sm text-brand-text/70 mt-1" data-id="element-397">
                        {plan.desc}
                      </p>
                      <p className="text-[11px] md:text-sm text-brand-aqua font-medium mt-1.5" data-id="element-398">
                        {plan.ideal}
                      </p>
                    </div>

                    <div className="text-right shrink-0" data-id="element-399">
                      <p className="text-xs md:text-sm text-brand-text/40 line-through leading-none" data-id="element-400">
                        {plan.oldPrice}
                      </p>
                      <p className={`font-serif font-bold text-lg md:text-2xl leading-tight mt-1 ${isSelected ? 'text-brand-aqua' : 'text-brand-text'}`} data-id="element-401">
                        {plan.price}
                      </p>
                    </div>
                  </div>

                  {isSelected && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} className="mt-4 pt-4 border-t border-brand-aqua/10" data-id="element-402">
                      <ul className="space-y-1.5 text-sm" data-id="element-403">
                        {plan.includes.map((item, i) => <li key={i} className="text-brand-text/80" data-id="element-404">
                            {item}
                          </li>)}
                      </ul>
                    </motion.div>}
                </div>
              </div>
            </motion.button>;
      })}

        <motion.a href={selectedPlan.href} animate={{
        scale: [1, 1.025, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.04,
        y: -3,
        transition: {
          duration: 0.25
        }
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 md:py-5 text-sm md:text-lg font-bold text-white green-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer shadow-[0_0_20px_rgba(13,148,136,0.4)]" data-id="element-405">
          <span className="relative z-10" data-id="element-406">
            → QUIERO EL{' '}
            {selectedPlan.id === 'maestria' ? 'MEGAPACK' : 'KIT DIGITAL'}{' '}
            {selectedPlan.price.split(' ')[0]}
          </span>
        </motion.a>

        <p className="text-center text-xs md:text-sm text-brand-text/60 pt-2" data-id="element-407">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳
          Mercado Pago
        </p>
      </div>
    </Section>;
};